export enum LinkTarget {
  self = 'self',
  blank = 'blank',
  parent = 'parent',
  top = 'top'
}
